import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/views/layout/Layout";
import Setting from "@/views/setting/Setting";
import Login from "@/views/login/Login";
import store from "@/store";
import system from "./system";
import iot from "./iot";
import workPlan from "./workPlan";
import device from "./device";
import patrol from "./patrol";
import machine from "./machine";
import material from "./material";
import material1 from "./materialSetting";
import irrigation from "./irrigation";
import moving from "./moving";
import statement from "./statement";
import file from "./file";
import person from "./person";
import overview from "./overview";
import projectFile from "./projectFile";
import project from "./project";
import wflow from "./wflow";
import mowLawn from "./mowLawn";
import seedling from "./seedling";
import mistForest from "./mistForest";
import operate from "./operate";
import assessmentScore from "./assessmentScore";
import tourist from "./tourist";

import { Message } from "element-ui";

Vue.use(VueRouter);

// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
// 临时修复路由跳转为当前路由报错问题
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

// const routes = [
//   {
//     path: '/',
//     name: 'layout',
//     component: Layout,
//     children: [
//       ...workPlan,
//       ...device,
//       ...patrol,
//       ...machine,
//       ...material,
//       ...irrigation,
//       ...moving,
//       ...statement,
//       ...file,
//       ...person,
//       ...overview,
//       {
//         path: '/404',
//         component: () => import('@/views/404.vue'),
//         meta: { title: '404' }
//       }
//     ]
//   },
//   {
//     path: '/(new|edit)',
//     component: () => import('@/views/project/Project.vue')
//   },
//   {
//     path: '/measure',
//     name: 'Measure',
//     component: () => import('@/views/measure/Layout.vue')
//   },
//   {
//     path: '/login',
//     component: Login
//   },
//   {
//     path: '/setting',
//     name: 'setting',
//     component: Setting,
//     children: [
//       {
//         path: '/webview',
//         name: 'webview',
//         meta: {
//           hasBack: false
//         },
//         component: () => import('@/views/other/Webview.vue')
//       },
//       ...system,
//       ...iot,
//       ...projectFile,
//       ...project,
//       ...material1,
//       ...wflow,
//       ...mowLawn,
//       ...seedling,
//       ...mistForest,
//       ...operate
//     ]
//   }
// ]

const routes = [
  {
    path: "/",
    name: "layout",
    component: Layout,
    children: [
      ...system,
      ...iot,
      ...mistForest,
      ...material1,
      ...wflow,
      ...device,
      ...projectFile,
      ...mowLawn,
      ...project,
      ...operate,
      ...seedling,
      ...assessmentScore,
      ...tourist,
      {
        path: "/measure",
        name: "Measure",
        component: () => import("@/views/measure/Layout.vue"),
      },
      {
        path: "/importCad",
        name: "importCad",
        meta: {
          title: "CAD导入",
          hasBack: true,
          backUrl: "/projectList/detail/cad",
          activeMenu: "/projectList",
        },
        component: () => import("@/views/layout/map/VjMap.vue"),
      },
      {
        path: "/home",
        name: "Home",
        meta: { activeMenu: "/home/board" },
        component: () => import("@/views/home/Home.vue"),
        children: [
          {
            path: "board",
            name: "Board",
            meta: {
              hasBack: false,
              activeMenu: "/home/board"
            },
            component: () => import("@/views/home/Board.vue"),
          },
          {
            path: "map",
            name: "Map",
            meta: {
              hasBack: false,
              activeMenu: "/home/board",
            },
            component: () => import("@/views/home/Map.vue"),
            children: [
              ...overview,
              ...patrol,
              ...workPlan,
              ...machine,
              ...material,
              ...irrigation,
              ...moving,
              ...statement,
              ...person,
              ...file,
            ],
          },
        ],
      },
      {
        path: "/webview",
        name: "webview",
        meta: { hasBack: false, activeMenu: "/webview" },
        component: () => import("@/views/other/Webview.vue"),
      },
      {
        path: "/404",
        component: () => import("@/views/404.vue"),
        meta: { title: "404" },
      },
    ],
  },
  {
    path: "/login",
    component: Login,
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (!to.matched.length) {
    next("/404");
  } else if (to.path !== "/login" && !store.state.token) {
    if (to.path !== "/") {
      Message.error("您还未登录或者登录已过期, 请先登录!");
    }
    next({ path: "/login", replace: true });
  } else {
    next();
  }
});

export default router;
